import { render } from "./RestaurantOverview.vue?vue&type=template&id=76309a0f"
import script from "./RestaurantOverview.vue?vue&type=script&lang=js"
export * from "./RestaurantOverview.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__